import { motion } from "framer-motion";

const formats = [
  {
    id: 1,
    label: "Formato 01",
    title: "EXTERIOR",
    subtitle: "Impacto Urbano (OOH)",
    desc: "Grandes gráficas instaladas sobre las fachadas de edificios residenciales. Máximo impacto visual en las arterias más transitadas de Chile.",
    img: "https://customer-assets.emergentagent.com/job_rpc-chile/artifacts/59w7atji_Ooh.png",
    span: "col-span-1 md:col-span-2",
    tall: true,
  },
  {
    id: 2,
    label: "Formato 02",
    title: "CIERRES PERIMETRALES",
    subtitle: "Edificios en Construcción",
    desc: "Publicidad instalada en los cierres perimetrales de obras y proyectos en construcción. Alta frecuencia visual en zonas de alta circulación.",
    img: "https://customer-assets.emergentagent.com/job_rpc-chile/artifacts/kzsi3sme_Gemini_Generated_Image_ymoqksymoqksymoq.png",
    span: "col-span-1",
    tall: true,
  },
  {
    id: 3,
    label: "Formato 03",
    title: "BRANDING EN ACCESOS",
    subtitle: "Portones Vehiculares",
    desc: "Publicidad estratégica en accesos, portones y entradas vehiculares de edificios residenciales. Exposición directa y frecuente.",
    img: "https://customer-assets.emergentagent.com/job_rpc-chile/artifacts/33nsi3p6_Gemini_Generated_Image_g31zxzg31zxzg31z.png",
    span: "col-span-1",
    tall: false,
  },
  {
    id: 4,
    label: "Formato 04",
    title: "PANTALLAS DIGITALES",
    subtitle: "Interior del Edificio",
    desc: "Pantallas LED y digitales instaladas dentro de lobbies, halls y zonas comunes de edificios residenciales premium.",
    img: "https://customer-assets.emergentagent.com/job_rpc-chile/artifacts/2g1nkpxj_Pantalla%20edimeda.jpg",
    span: "col-span-1",
    tall: false,
  },
  {
    id: 5,
    label: "Formato 05",
    title: "PUBLICIDAD EN AZOTEA",
    subtitle: "Vista Panorámica",
    desc: "Grandes formatos en azoteas de edificios, visibles desde altura y desde puntos clave de la ciudad. Presencia icónica en el skyline urbano.",
    img: "https://customer-assets.emergentagent.com/job_rpc-chile/artifacts/ja6fl9us_Gemini_Generated_Image_ax9tzeax9tzeax9t.png",
    span: "col-span-1",
    tall: false,
  },
];

const SoporteCard = ({ format, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
    data-testid={`soporte-card-${format.id}`}
    className={`${format.span} relative group overflow-hidden`}
    style={{
      height: format.tall ? "520px" : "320px",
      cursor: "default",
    }}
  >
    {/* Image */}
    <img
      src={format.img}
      alt={format.title}
      className="absolute inset-0 w-full h-full object-cover"
      style={{ transition: "transform 0.8s ease", transform: "scale(1)" }}
      onMouseEnter={(e) => (e.target.style.transform = "scale(1.06)")}
      onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
    />

    {/* Gradient overlay */}
    <div
      className="absolute inset-0"
      style={{
        background: "linear-gradient(to top, rgba(5,5,5,0.95) 0%, rgba(5,5,5,0.3) 60%, transparent 100%)",
      }}
    />

    {/* Border */}
    <div
      className="absolute inset-0"
      style={{
        border: "1px solid rgba(255,255,255,0.06)",
        transition: "border-color 0.4s",
      }}
    />

    {/* Cyan line on hover */}
    <div
      className="absolute bottom-0 left-0"
      style={{
        height: "2px",
        backgroundColor: "#00E0FF",
        width: "0",
        transition: "width 0.5s ease",
      }}
    />

    {/* Content */}
    <div className="absolute bottom-0 left-0 right-0 p-8 z-10">
      <span
        className="font-body font-bold uppercase"
        style={{
          fontSize: "10px",
          letterSpacing: "0.25em",
          color: "#00E0FF",
          display: "block",
          marginBottom: "8px",
        }}
      >
        {format.label}
      </span>
      <h3
        className="font-heading font-bold uppercase text-white"
        style={{ fontSize: "clamp(20px, 2.5vw, 28px)", letterSpacing: "0.05em", marginBottom: "8px" }}
      >
        {format.title}
      </h3>
      <p
        className="font-body font-semibold text-zinc-400"
        style={{ fontSize: "12px", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "12px" }}
      >
        {format.subtitle}
      </p>
      <p
        className="font-body text-zinc-500"
        style={{ fontSize: "13px", lineHeight: 1.7, fontWeight: 300, maxWidth: "420px" }}
      >
        {format.desc}
      </p>
    </div>

    {/* Hover bottom line effect */}
    <style>{`
      [data-testid="soporte-card-${format.id}"]:hover > div:nth-child(4) {
        width: 100%;
      }
    `}</style>
  </motion.div>
);

const Soportes = () => (
  <section
    id="soportes"
    data-testid="soportes-section"
    style={{ backgroundColor: "#050505", paddingTop: "60px", paddingBottom: "120px" }}
  >
    <div className="edi-container">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7 }}
        className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
      >
        <div>
          <span className="section-label">Nuestros Formatos</span>
          <div style={{ marginTop: "20px" }}>
            <div className="line-accent" />
          </div>
          <h2
            className="section-heading"
            style={{ fontSize: "clamp(42px, 5.5vw, 80px)" }}
          >
            Soportes<br />
            <span style={{ color: "#00E0FF" }}>Publicitarios</span>
          </h2>
        </div>
        <p
          className="font-body text-zinc-500 md:max-w-sm"
          style={{ fontSize: "14px", lineHeight: 1.8, fontWeight: 300 }}
        >
          Cinco formatos estratégicos diseñados para conectar marcas con residentes en los puntos más relevantes de cada edificio.
        </p>
      </motion.div>

      {/* Bento Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {formats.map((format, i) => (
          <SoporteCard key={format.id} format={format} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export { Soportes };
